import React from "react";
import { Reveal } from "../tools/Reveal";
import { RevealGroup } from "../tools/RevealGroup";
import "../styles/AboutMe.scss";

function AboutMe() {
  // ab = about me
  return (
    <div className="ab" id="about-me">
      <RevealGroup>
        <div className="section-title-wrapper">
          <Reveal direction={"top"}>
            <h5 className="section-title">ABOUT</h5>
            <h2 className="section-subtitle">Get to know me</h2>
          </Reveal>
        </div>
        <div className="ab-content-wrapper">
          <section className="ab-left">
            <Reveal direction={"left"}>
              <p className="ab-info">
                I’m a Cypriot Frontend Developer specializing in React and
                JavaScript. I began coding in 2022 after studying Economics and
                completing a full-stack bootcamp, where I found my passion for
                coding.
              </p>
              <p className="ab-info">
                As my first position as the sole front-end developer at a
                startup, I built projects from scratch using JavaScript, HTML,
                CSS and used TypeScript working on legacy code/projects. My
                responsibilities also included structuring codebases, optimizing
                performance, and ensuring accessibility with WCAG guidelines and
                responsivess of the websites. I’ve worked closely with
                designers, clients, and backend developers to translate Figma
                designs into responsive, secure websites and tested interfaces
                using Jest.
              </p>
              <p className="ab-info">
                I enjoy building accessible, user-friendly websites and turning
                complex ideas into clean, maintainable code. I’m eager to learn
                and grow with a collaborative team on impactful projects.
              </p>
            </Reveal>
          </section>
          <section className="ab-right">
            <Reveal direction={"right"}>
              <div className="ab-stats-container">
                <div className="ab-stat-box">
                  <div className="ab-stat-top">3+</div>
                  <div className="ab-stat-bottom">Years of Experience</div>
                </div>
                <div className="ab-stat-box">
                  {" "}
                  <div className="ab-stat-top">10+</div>
                  <div className="ab-stat-bottom">Projects Worked On</div>
                </div>
                <div className="ab-stat-box">
                  <div className="ab-stat-top">5+</div>
                  <div className="ab-stat-bottom">Happy Clients</div>
                </div>
              </div>
            </Reveal>
          </section>
        </div>
      </RevealGroup>
    </div>
  );
}

export default AboutMe;
